// extracted by mini-css-extract-plugin
export default {"Box":"SubIssueAddedEvent-module__Box--N8W4N","Box_1":"SubIssueAddedEvent-module__Box_1--eiyEN"};